// export const api_host = "http://localhost:8000/api/";
// export const image_host = "http://localhost:8000";

// export const api_host = "https://purple-mouse-974191.hostingersite.com/api/";
// export const image_host = "https://purple-mouse-974191.hostingersite.com";

export const api_host = "https://smartex-sy.com/api/";
export const image_host = "https://smartex-sy.com";

// export const api_host = "https://store.byrings.pro/api/";
// export const image_host = "https://store.byrings.pro/";


// export const api_host = "http://192.168.0.107:8000/api/";
// export const image_host = "http://192.168.0.107:8000";

// export const api_host = "https://nemoo.hometecs.sy/api/";
// export const image_host = "https://nemoo.hometecs.sy";

